/**
 * LoreBot MFE Route
 * 
 * Loads and renders the LoreBot MFE with error boundary protection.
 * 
 * @module components/mfe/LoreBotRoute
 */

import React from 'react';
import { MFELoader } from './MFELoader';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const LoreBotRoute: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <ErrorBoundary onReset={() => window.location.reload()}>
      <MFELoader
        mfeName="LoreBot"
        accessToken={token}
        refUserId={user.id}
        onLogout={logout}
      />
    </ErrorBoundary>
  );
};

